import React, { memo, useContext } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { GSIcon } from 'src/components/shared/GSIcon'
import { ReActivationFilterValue } from 'src/interfaces/contractor'
import { colors } from 'src/theme'

const reActivationOptions = [
  {
    value: ReActivationFilterValue.Enabled,
    label: 'Enabled',
    component: (
      <Typography variant="subtitle1" css={tw`font-normal`} color={colors.SHADES_GREY_400}>
        Enabled
      </Typography>
    ),
  },
  {
    value: ReActivationFilterValue.Disabled,
    label: 'Disabled',
    component: (
      <Typography variant="subtitle1" css={tw`font-normal`} color={colors.SHADES_GREY_400}>
        Disabled
      </Typography>
    ),
  },
]

const ContractorReActivationSelectComponent = () => {
  const { reActivationFilter, setReActivationFilter } = useContext(ContractorsTableContext)

  return (
    <TableSelect<ReActivationFilterValue>
      title="Re-Activation"
      icon={<GSIcon iconName="gs_toggle" width={20} height={20} css={tw`text-black`} />}
      options={reActivationOptions}
      selectedValues={reActivationFilter}
      onSelect={setReActivationFilter}
    />
  )
}

export const ContractorReActivationSelect = memo(ContractorReActivationSelectComponent)
